import styled, { css } from 'styled-components';

export const CDLiveCountSection = styled.section`
  text-align: center;
  ${(props) =>
    !props.category
      ? css`
          margin: 30px 0;
        `
      : `margin: 10px 0;`}
  .heading {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    padding-top: 18px;
    span {
      color: ${(props) => (props.lactoMama ? props.tabThemeColor || '#498A5B' : '#498A5B')};
    }
  }
`;

export const CountNumberDiv = styled.div`
  padding: ${(props) =>
    props.happyTuesday ? '30px 0' : props.lactoMama ? '20px 0 0px' : '10px 0'};
`;

export const CountNumber = styled.span`
  background-color: ${(props) => props.textBackground || '#f9f9f9'};
  box-shadow: 0 0.2px 1px 0 rgb(0 0 0 / 20%);
  color: ${(props) => props.textColor || '#3bb3a7'};
  font-size: 38px;
  font-weight: 600;
  padding: 0 7px;
  margin: 0 2px;
  letter-spacing: 0.2px;
  overflow: hidden;
  display: inline-block;
  height: 46px;

  &.numberAnimation {
    span {
      position: relative;
      display: inline-block;
      overflow: hidden;
      animation: numAnim 3s ease;
      animation-iteration-count: 1;
      @keyframes numAnim {
        0% {
          transform: translateY(100%);
        }
        25% {
          transform: translateY(0%);
        }
        50% {
          transform: translateY(0%);
        }
        82% {
          transform: translateY(0%);
        }

        100% {
          transform: translateY(-100%);
        }
      }
    }
  }
`;

export const Comma = styled.span`
  font-size: 38px;
  font-weight: 600;
  color: ${(props) => props.color || '#3bb3a7'};
  margin: 0 2px;
`;

export const BabyBumpsSafeText = styled.p`
  font-weight: 500;
  color: ${(props) => (props.lactoMama ? '#414141' : 'hsl(0deg, 0%, 0%, 80%)')};
  font-size: ${(props) => (props.lactoMama ? '14px' : '')};
`;
